export enum IntegrationCategories {
    git = "git",
    work = "work",
    collaboration = "collaboration",
    wellbeing = "wellbeing",
    fragmentation = "fragmentation",
    meetings = "meetings",
    slack = "slack",
    pm = "pm",
}

export enum ColumnTypes {
    stageDuration = "stage-duration",
    string = "string",
    number = "number",
    chip = "chip",
    ago = "ago",
}

export enum HeaderTypes {
    link = "link",
    string = "string",
}

export enum HTMLComponentTypes {
    radio = "radio",
    switch = "switch",
    dropdown = "dropdown",
}

export enum DataTypesNames {
    number = "number",
    string = "string",
    datetime = "datetime",
    duration = "duration",
    dow = "dow",
    weekday = "weekday",
    arrayToJoin = "arrayToJoin",
    chip = "chip",
}
